import PropTypes from 'prop-types';
import React, {Component} from 'react';

class RadioGroup extends Component {
    static propTypes = {
        /** name property that gets passed on to the inputs. Should be similar to a variable name (i.e. creditCardChoices) */
        name: PropTypes.string.isRequired,
        /** Radio group's label to be read by screen readers */
        ariaLabel: PropTypes.string.isRequired
    };

    render() {
        return (
            <div id={this.props.name} aria-label={this.props.ariaLabel} role="radiogroup">
                {this.props.children.map(
                    /* istanbul ignore next */
                    (child, i) => {
                        return React.cloneElement(child, {name: this.props.name, key: `radio-${this.props.name}-${i}`});
                    }
                )}
            </div>
        );
    }
}

export default RadioGroup;
